export interface DashboardCardConfig {
    id: string;
    title: string;
    column: 1 | 2;
    order: number;
    visible: boolean;
}

export interface DashboardSettings {
    cards: DashboardCardConfig[];
}

export const DEFAULT_DASHBOARD_CARDS: DashboardCardConfig[] = [
    // Column 1 Cards
    { id: "patient-demographics", title: "Demographics", column: 1, order: 1, visible: true },
    { id: "eligible-programs", title: "Eligible Programs", column: 1, order: 2, visible: true },
    { id: "notes", title: "Notes", column: 1, order: 3, visible: true },
    { id: "subscriptions", title: "Subscriptions", column: 1, order: 4, visible: true },
    { id: "shipments", title: "Shipments", column: 1, order: 5, visible: true },
    { id: "insurance-plans", title: "Insurance Plans", column: 1, order: 6, visible: true },
    { id: "voicemails", title: "Voicemails", column: 1, order: 7, visible: true },
    { id: "emergency-contacts", title: "Emergency Contacts", column: 1, order: 8, visible: true },
    { id: "linked-patients", title: "Linked Patients", column: 1, order: 9, visible: true },
    { id: "allergies", title: "Allergies", column: 1, order: 10, visible: true },
    { id: "insurance-upload", title: "Insurance Upload", column: 1, order: 11, visible: true },
    { id: "case-history", title: "Case History", column: 1, order: 12, visible: true },
    { id: "rx-transfer-history", title: "Transfer History", column: 1, order: 13, visible: true },
    { id: "follow-up-history", title: "Follow Up History", column: 1, order: 14, visible: true },
    { id: "non-profile-medications", title: "Non-Profile Medications", column: 1, order: 15, visible: true },
    { id: "call-log", title: "Call Log", column: 1, order: 16, visible: true },

    // Column 2 Cards
    { id: "orders", title: "Orders", column: 2, order: 1, visible: true },
    { id: "autorefill-subscriptions", title: "Autorefill Subscriptions", column: 2, order: 2, visible: true },
    { id: "prescriptions", title: "Scripts", column: 2, order: 3, visible: true },
    { id: "prior-authorization", title: "Prior Authorization", column: 2, order: 4, visible: true },
    { id: "electronic-prior-auth", title: "Electronic Prior Authorization", column: 2, order: 5, visible: true },
    { id: "consultations", title: "Consultations", column: 2, order: 6, visible: true },
    { id: "patient-assistance-program", title: "Patient Assistance Program", column: 2, order: 7, visible: true },
    { id: "available-acceptances", title: "Available Acceptances", column: 2, order: 8, visible: true },
    { id: "acceptance-records", title: "Acceptance Records", column: 2, order: 9, visible: true },
    { id: "tasks", title: "Tasks", column: 2, order: 10, visible: true },
];